<template>
	<div class="edit_wrap">
		<div class="edit_top">
			<div class="edit_tab" :class="{ 'active_tab': isStep === 1 }" @click="changeTab(1)">商家信息</div><!--
			--><div class="edit_tab" :class="{ 'active_tab': isStep === 2 }" @click="changeTab(2)">财务信息</div><!--
			--><div class="edit_tab" :class="{ 'active_tab': isStep === 3 }" @click="changeTab(3)">联系人信息</div><!--
			--><div class="edit_tab" :class="{ 'active_tab': isStep === 4 }" @click="changeTab(4)">合作协议信息</div><!--
			--><div class="edit_tab" :class="{ 'active_tab': isStep === 5 }" @click="changeTab(5)">品牌品类信息</div><!--
			-->
		</div>
		<basicInfo v-show="isStep == 1"></basicInfo>
		<financeInfo v-show="isStep == 2"></financeInfo>
		<contactInfo v-show="isStep == 3"></contactInfo>
		<argeementLis v-show="isStep == 4"></argeementLis>
		<brandList v-show="isStep == 5"></brandList>
		<div align="center" style="margin-top: 20px;"  v-show="showButton == 1">
			<el-button  type="primary" icon="arrow-left" v-show="isStep > 1" @click="upPage">上一页</el-button>
			<el-button  type="primary" v-show="isStep < 5" @click="nextPage">下一页<i class="el-icon-arrow-right el-icon--right"></i></el-button>
		</div>
	</div>
</template>

<script type="text/javascript">
	import basicInfo1 from './basicInfo.vue'
	import brandList1 from './brandList.vue'
	import financeInfo1 from './financeInfo.vue'
    import contactInfo1 from './contactInfo.vue'
    import argeementList1 from './agreementList.vue'
    export default {
        components: {
            basicInfo: basicInfo1,
            financeInfo: financeInfo1,
            contactInfo: contactInfo1,
            argeementLis:argeementList1,
            brandList: brandList1
        },
        data () {
            return {
                showButton:1,
                brandListShowButton:1,
                isActiveTab: true,
                isStep: 1
            }
        },
        methods: {
            changeTab(step){
                if(step==5 && this.brandListShowButton==0) {
                    this.showButton = 0;
                }else{
                    this.showButton = 1;
                }
                this.isStep = step;
            },
            upPage(){
                this.showButton = 1;
                if(this.isStep > 1) {
                    this.isStep = this.isStep - 1;
                }
            },
            nextPage(){
                if(this.isStep < 5) {
                    if(this.isStep == 4 && this.brandListShowButton == 0) {
                        this.showButton = 0;
                    }else{
                        this.showButton = 1;
                    }
                    this.isStep = this.isStep + 1;
                }
            }
        },
        mounted(){
            this.suppliersId = this.$route.query.suppliersId;
            var step = this.$route.query.isStep;
            step = step * 1;
            if(step && step > 1 && step < 6) {
                this.changeTab(step);
            }
        }
    };
</script>

<style type="text/css" lang="less" scoped>
	.edit_wrap {
		width: 1050px;
	  // height: 4000px;
	  margin: 50px auto;
	  border: 1px solid #eee;
	  // padding: 20px;
	  .edit_tab {
	  	display: inline-block;
	  	width: 20%;
	  	height: 46px;
	  	text-align: center;
	  	line-height: 46px;
	  	color: #fff;
	  	background: #ff6c83;
	  }
	  .active_tab {
	  	background: #ff4a7d;
	  }
	  .tip_word {
	  	margin-top: 20px;
	  	width: 1048px;
	  	height: 88px;
	  	background: #f9f9f9;
	  	padding: 10px;
	  }
	}
</style>


// WEBPACK FOOTER //
// suppliercommonPages.vue?1624a9a8